"use client"

import { Modal } from "antd"
import SignupForm from "./SignupForm"
import { forwardRef, useCallback, useImperativeHandle, useState } from "react"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type SignupModalProps = {
  onSwitchToLogin?: () => void;
};

export type SignupModalRef = {
  open: () => void,
  close: () => void,
}

const SignupModal = forwardRef<SignupModalRef, SignupModalProps>((props, ref) => {
  const [open, setOpen] = useState<boolean>(false)
  const isDesktop = useIsDesktop()

  const handleOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => {
    return {
      open: handleOpen,
      close: handleClose
    }
  }, [handleClose, handleOpen])

  return (
    <Modal
      centered
      styles={{
        container: {
          padding: '2.4rem',
          paddingBottom: 0
        }
      }}
      onCancel={handleClose}
      open={isDesktop && open}
      footer={() => null}
      width={"48rem"}
    >
      <SignupForm onSwitchToLogin={props.onSwitchToLogin} handleClose={handleClose}/>
    </Modal>
  )
})

export default SignupModal